<template>
  <div class="col-12 col-md-7">
    <div class="mid-container">
      <NavMenu/>
      <main class="content">
          <div class="row">
            <div class="col-6 col-md-9">
              <div class="tittle-content">
                <img class="subtittle-img" src="../assets/img/creelo.webp" alt="Créelo, Créalo">
                <p class="subtittle-text">&#10230; Rápido, Confiable y Flexible</p>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="calc-container">
                <router-link class="calc-img-container" to="/Creditos/Calculadora-Credito"><img class="calc-img" src="../assets/img/btn-crealo-shadow.webp" alt="Calcula tu crédito aquí"></router-link>
              </div>
            </div>
            <div class="col-12 col-md-10">
              <p class="general-text">En Sihusel, creemos en tu potencial para lograr grandes cosas. Nuestra misión es proporcionarte las herramientas financieras más avanzadas y competitivas del mercado. Así que, si tienes un proyecto en mente, estamos aquí para respaldarte en cada paso del camino y hacer que tu visión se convierta en realidad.</p>
            </div>
          </div>
      </main>
      <FooterSihusel/>
    </div>
  </div>
  <div class="d-none d-md-block col-4">
    <div class="right-container inicio-slider">
    </div>
  </div>
</template>

<script>
import FooterSihusel from './FooterSihusel.vue';
import NavMenu from './NavMenu.vue';

export default {
  name: 'InicioComponent',
  components: {
    NavMenu,
    FooterSihusel
  }
}
</script>

